import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import {environment} from '../../../environments/environment';

@Injectable()
export class MainInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const url = environment.BACK_URL ? (environment.BACK_URL + '/api/') : 'https://dev.api.mykoolcat.com/api/';
    // if (document.location.hostname === 'koolcat.pk.biz.ua') {
    //   url = 'https://koolcat.pk.biz.ua/api/';
    // } else if (document.location.hostname.split('.')[0] === 'sys') {
    //     url = 'https://api.mykoolcat.com/api/';
    // }
    req = req.clone({
      url: url + req.url
    });
    return next.handle(req);
  }
}
